import "@/App.css";
import {
    createBrowserRouter,
    RouterProvider,
    Navigate,
    useParams,
} from "react-router-dom";
import { AuthProvider, ProtectedRoute } from "@/lib/auth";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import BusinessEditor from "@/pages/BusinessEditor";
import Settings from "@/pages/Settings";
import PublicBusinessPage from "@/pages/PublicBusinessPage";
import AdminLayout from "@/components/AdminLayout";
import { Toaster } from "@/components/ui/sonner";

const cardRedirects = {
    "DP-001": "/b/strawberry-corner",
    "DP-002": "/b/strawberry-corner",
    "DP-003": "/b/strawberry-corner",
    "DP-004": "/b/strawberry-corner",
    "DP-005": "/b/strawberry-corner",
    "DP-006": "/b/strawberry-corner",
    "DP-007": "/b/strawberry-corner",
    "DP-008": "/b/strawberry-corner",
    "DP-009": "/b/strawberry-corner",
    "DP-010": "/b/strawberry-corner",
};

function CardRedirect() {
    const { cardId } = useParams();
    const normalizedCardId = cardId?.toUpperCase();
    const destination = cardRedirects[normalizedCardId];

    if (!destination) {
        return <Navigate to="/b/demo-restaurant" replace />;
    }

    return <Navigate to={destination} replace />;
}

// Data router — required for useBlocker() (unsaved-changes navigation guard).
const router = createBrowserRouter([
    { path: "/", element: <Navigate to="/admin" replace /> },
    { path: "/login", element: <Login /> },

    // روابط البطاقات الثابتة
    { path: "/c/:cardId", element: <CardRedirect /> },

    // صفحات المطاعم
    { path: "/b/:slug", element: <PublicBusinessPage /> },

    {
        element: (
            <ProtectedRoute>
                <AdminLayout />
            </ProtectedRoute>
        ),
        children: [
            { path: "/admin", element: <Dashboard /> },
            { path: "/admin/new", element: <BusinessEditor /> },
            { path: "/admin/edit/:id", element: <BusinessEditor /> },
            { path: "/admin/settings", element: <Settings /> },
        ],
    },

    { path: "*", element: <Navigate to="/" replace /> },
]);

function App() {
    return (
        <div className="App">
            <AuthProvider>
                <RouterProvider router={router} />
                <Toaster position="top-right" richColors />
            </AuthProvider>
        </div>
    );
}

export default App;
